import React from 'react'
import { 
    Tooltip,IconButton
    } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';


const DeleteButton = ({...props}) => {

    const { handleDelete, pid } = props;

    return (
        <Tooltip title="Delete" onClick={e => handleDelete(pid)}>
            <IconButton aria-label="delete" size="large">
                <DeleteIcon />
            </IconButton>
        </Tooltip>
    );
}

export default DeleteButton;